export default __webpack_public_path__ + "static/media/creators-whiteboarding1.458caa8a.png";